module.exports = __webpack_public_path__ + "img/15582e5.png";